module.exports = __webpack_public_path__ + "static/img/logo.85d26ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/logo.png
// module id = ThK+
// module chunks = 23